import React, { useState, useEffect } from 'react';

const ClientSubscriptions = () => {
  const [user, setUser] = useState({ id: '123', role: 'client' }); // Mock user for now
  const [subscription, setSubscription] = useState(null);
  const [billingHistory, setBillingHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  // Mock data for billing history (since we’re focusing on UI)
  useEffect(() => {
    const loadData = async () => {
      // Ensure loader shows for at least 2 seconds
      const startTime = Date.now();
      
      // Mock subscription data
      setSubscription({
        plan: 'BEGINNER',
        price: 10,
        minutes: 650,
        status: 'active',
      });

      // Mock billing history data
      setBillingHistory([
        { date: '01/02/2025', details: 'Beginner, Monthly', amount: 10.00, invoiceUrl: '#' },
        { date: '02/02/2025', details: 'Beginner, Monthly', amount: 10.00, invoiceUrl: '#' },
        { date: '03/03/2025', details: 'Beginner, Monthly', amount: 10.00, invoiceUrl: '#' },
      ]);

      // Calculate elapsed time and wait if necessary
      const elapsedTime = Date.now() - startTime;
      const remainingTime = 320 - elapsedTime;
      
      if (remainingTime > 0) {
        await new Promise(resolve => setTimeout(resolve, remainingTime));
      }
      
      setLoading(false);
    };

    loadData();
  }, []);

  if (loading) return (
    <div className="flex items-center justify-center h-[calc(100vh-4rem)] sm:h-[calc(100vh-5rem)] bg-gray-50">
      <div className="flex flex-col items-center">
        <div className="animate-spin rounded-full h-12 w-12 sm:h-16 sm:w-16 border-t-4 border-blue-500 border-solid"></div>
        <p className="mt-4 text-lg text-gray-600">Loading your subscription details...</p>
      </div>
    </div>
  );
  return (
    <div className="w-full h-[calc(100vh-4rem)] sm:h-[calc(100vh-5rem)] overflow-y-auto hide-scrollbar p-4 sm:p-6 lg:p-8 bg-gray-50">
      {/* Container with max-width for larger screens */}
      <div className=" mx-auto">
        {/* Header */}
        <h1 className="text-2xl sm:text-3xl font-bold mb-6 text-gray-800">
          OUR SUBSCRIPTION PLAN
        </h1>

        {/* Subscription Plans */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 mb-8">
          {/* Current Plan */}
          <div className="border-2 border-blue-500 rounded-lg p-4 sm:p-6 shadow-md bg-white">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4">
              <div>
                <h2 className="text-lg sm:text-xl font-semibold text-gray-800">
                  {subscription?.plan || 'BEGINNER'}
                </h2>
                <p className="text-gray-500 text-sm sm:text-base">
                  {subscription?.minutes || '650'} Min Remaining
                </p>
              </div>
              <div className="text-lg sm:text-xl font-bold text-gray-800 mt-2 sm:mt-0">
                ${subscription?.price || '10'}/Month
              </div>
            </div>
            <button className="w-full sm:w-auto bg-gray-800 text-white px-4 py-2 rounded-lg hover:bg-gray-700 text-sm sm:text-base">
              Cancel Subscription
            </button>
            <p className="text-red-500 text-xs sm:text-sm mt-2">
              {subscription?.status === 'cancelled' ? 'Plan will expire in 650 min' : ''}
            </p>
          </div>

          {/* Upgrade Plan */}
          <div className="bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg p-4 sm:p-6 shadow-md">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4">
              <div>
                <h2 className="text-lg sm:text-xl font-semibold">UPGRADE PLAN</h2>
                <p className="text-xs sm:text-sm">Upgrade Your plan with 1000 min</p>
              </div>
              <div className="text-lg sm:text-xl font-bold mt-2 sm:mt-0">$10/Month</div>
            </div>
            <button className="w-full sm:w-auto bg-orange-500 text-white px-4 py-2 rounded-lg hover:bg-orange-400 text-sm sm:text-base">
              Upgrade
            </button>
          </div>
        </div>

        {/* Payment Methods */}
        <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-gray-800">
          PAYMENT METHOD
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-8">
          {/* Credit Card (First) */}
          <div className="border rounded-lg p-4 sm:p-5 shadow-md bg-white flex items-center">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg"
              alt="Mastercard"
              className="w-10 h-10 sm:w-12 sm:h-12 mr-3 sm:mr-4"
            />
            <div>
              <p className="text-gray-600 text-sm sm:text-base">Credit Card</p>
              <p className="text-gray-800 text-sm sm:text-base">**** **** **** 3213</p>
            </div>
          </div>

          {/* Debit Card (Second) */}
          <div className="border rounded-lg p-4 sm:p-5 shadow-md bg-white flex items-center">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg"
              alt="Visa"
              className="w-10 h-10 sm:w-12 sm:h-12 mr-3 sm:mr-4"
            />
            <div>
              <p className="text-gray-600 text-sm sm:text-base">Debit Card</p>
              <p className="text-gray-800 text-sm sm:text-base">**** **** **** 3213</p>
            </div>
          </div>

          {/* Add New Card */}
          <div className="border rounded-lg p-4 sm:p-5 shadow-md bg-white flex items-center justify-center">
            <button className="text-gray-500 text-2xl sm:text-3xl">+</button>
          </div>
        </div>

        {/* Billing History */}
        <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-gray-800">
          BILLING HISTORY
        </h2>
        <div className="border rounded-lg shadow-md bg-white overflow-x-auto">
          <table className="w-full text-left text-sm sm:text-base">
            <thead>
              <tr className="bg-gray-100">
                <th className="p-3 sm:p-4">DATE</th>
                <th className="p-3 sm:p-4">DETAILS</th>
                <th className="p-3 sm:p-4">AMOUNT</th>
                <th className="p-3 sm:p-4">DOWNLOAD INVOICE</th>
              </tr>
            </thead>
            <tbody>
              {billingHistory.map((entry, index) => (
                <tr key={index} className="border-t">
                  <td className="p-3 sm:p-4">{entry.date}</td>
                  <td className="p-3 sm:p-4">{entry.details}</td>
                  <td className="p-3 sm:p-4">${entry.amount.toFixed(2)}</td>
                  <td className="p-3 sm:p-4">
                    <a
                      href={entry.invoiceUrl}
                      className="text-blue-500 hover:underline text-sm sm:text-base"
                    >
                      Invoice {entry.date}
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ClientSubscriptions;